export const LEXUS_BASE_URL = "https://www.lexus.com"
export const TOYOTA_BASE_URL = "https://www.toyota.com"
export const LEXUS_LOGO_URL = "https://www.lexus.com/etc.clientlibs/lexus/clientlibs/lexus-react/resources/static/media/lexus_logo_english@2x.31995220.png"
